module.exports = __webpack_public_path__ + "media/arrow-up.e7b40cb0.svg";